<template>
  <div
    v-if="rootStore.is_page_loading"
    class="h-screen w-screen inset-0 fixed bg-secondary-black/35 z-[100] grid place-items-center text-idle-black"
  >
    <TsAnimatedBubbleLoader size="40" class="text-natural-grey" />
  </div>
</template>

<script setup lang="ts">
const TsAnimatedBubbleLoader = defineAsyncComponent(
  () => import("~/components/atoms/icons/TsAnimatedBubbleLoader.vue")
);

const {useRootStore} = await import('~/stores/root.store');
const rootStore = useRootStore();
</script>
